function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.76 14.197v-1.211c0-.368-.34-.666-.761-.666h-.347c-.42 0-.762.298-.762.666v2.906c0 .468-.434.847-.97.847h-.554c-.536 0-.97-.38-.97-.847V8.264c0-.468.434-.847.97-.847h.554c.536 0 .97.38.97.847v1.514c0 .367.341.665.762.665H10c.42 0 .762-.298.762-.665h.02c.097-.449.547-.787 1.089-.787h.277c.612 0 1.108.433 1.108.968v1.514h.003c.035.339.362.605.76.605h.346c.398 0 .725-.267.76-.607.06-.317.327-.574.683-.656.2-.046.355-.069.466-.069h.239c.612 0 1.109.434 1.109.969v1.416c0 .491-.422.905-.98.962-.146.015-.235.022-.268.022-.042 0-.16-.013-.352-.038-.413-.054-.757-.307-.888-.653l-.012-.03c-.086-.398-.366-.59-.757-.59h-.346c-.417 0-.756.292-.763.655v.738c0 .535-.496.968-1.108.968h-.277c-.613 0-1.11-.433-1.11-.968z"
});

var SvgTully = function SvgTully(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTully, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tully.b2891558.svg";
export { ForwardRef as ReactComponent };